module.exports = __webpack_public_path__ + "static/media/7. Entre líneas2, Mixta en tela, 100 x 100 cm, 2019 copy.04ba4d79.png";